// extracted by mini-css-extract-plugin
module.exports = {"faqTemplate":"FaqTemplate_faqTemplate__klWjx","roundHead":"FaqTemplate_roundHead__jsVgJ","faqListing":"FaqTemplate_faqListing__ZTByM","rotation":"FaqTemplate_rotation__g3Nmf"};